import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7955ec4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content_wrapper wrapper" }
const _hoisted_2 = { class: "content_body" }
const _hoisted_3 = { class: "mt-0" }
const _hoisted_4 = { class: "client_wrapper" }
const _hoisted_5 = { class: "elment_wrapper" }
const _hoisted_6 = { class: "elment_wrapper" }
const _hoisted_7 = { class: "elment_wrapper" }
const _hoisted_8 = { class: "elment_wrapper" }
const _hoisted_9 = { class: "elment_wrapper" }
const _hoisted_10 = { class: "elment_wrapper" }
const _hoisted_11 = { class: "elment_wrapper" }
const _hoisted_12 = { class: "contract_wrapper" }
const _hoisted_13 = { class: "elment_wrapper" }
const _hoisted_14 = { class: "elment_wrapper" }
const _hoisted_15 = { class: "elment_wrapper" }
const _hoisted_16 = { class: "elment_wrapper" }
const _hoisted_17 = { class: "elment_wrapper" }
const _hoisted_18 = { class: "w-100 mt-2 mb-3" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "corporate_organizations_wrapper" }
const _hoisted_21 = { class: "elment_wrapper" }
const _hoisted_22 = { class: "elment_wrapper" }
const _hoisted_23 = { class: "agreement_element_wrapper" }
const _hoisted_24 = { class: "agreement_element" }
const _hoisted_25 = { class: "agreement_element_label" }
const _hoisted_26 = { class: "agreement_element" }
const _hoisted_27 = { class: "agreement_element_label" }
const _hoisted_28 = { class: "button_wrapper" }

export function render(_ctx, _cache) {
  const _component_checkPhoneNumber = _resolveComponent("checkPhoneNumber")
  const _component_v_input = _resolveComponent("v-input")
  const _component_v_select = _resolveComponent("v-select")
  const _component_v_checkbox = _resolveComponent("v-checkbox")
  const _directive_maska = _resolveDirective("maska")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showCheckPhoneNumber)
      ? (_openBlock(), _createBlock(_component_checkPhoneNumber, {
          key: 0,
          clientId: 0,
          clubId: _ctx.selectedClub.id,
          prefilledPhone: _ctx.phone,
          onClose: _ctx.closeCheckPhoneNumber,
          onUpdatePhone: _ctx.onPhoneUpdated
        }, null, 8, ["clubId", "prefilledPhone", "onClose", "onUpdatePhone"]))
      : _createCommentVNode("", true),
    _createElementVNode("p", null, "phoneConfirmationRequired: " + _toDisplayString(_ctx.phoneConfirmationRequired), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('clients.create.create_new_client')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.lastname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.lastname) = $event)),
              label: _ctx.$t('clients.create.lastname'),
              height: "22",
              errorText: _ctx.lastnameErrorText,
              onFocus: _cache[1] || (_cache[1] = $event => (_ctx.lastnameErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.firstname,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.firstname) = $event)),
              label: _ctx.$t('clients.create.firstname'),
              height: "22",
              errorText: _ctx.firstnameErrorText,
              onFocus: _cache[3] || (_cache[3] = $event => (_ctx.firstnameErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.middlename,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.middlename) = $event)),
              label: _ctx.$t('clients.create.middlename'),
              height: "22",
              clearable: ""
            }, null, 8, ["modelValue", "label"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.email,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.email) = $event)),
              label: _ctx.$t('clients.create.email'),
              height: "22",
              errorText: _ctx.emailErrorText,
              onFocus: _cache[6] || (_cache[6] = $event => (_ctx.emailErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.phone,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.phone) = $event)),
              placeholder: "+7 (000) 000-00-00",
              label: _ctx.$t('clients.create.phone'),
              height: "22",
              errorText: _ctx.phoneErrorText,
              onFocus: _cache[8] || (_cache[8] = $event => (_ctx.phoneErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"]), [
              [_directive_maska, void 0, _ctx.options]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.birthday,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.birthday) = $event)),
              inputType: "date",
              label: _ctx.$t('clients.create.birthday'),
              height: "22",
              errorText: _ctx.birthdayErrorText,
              min: _ctx.minBirthdayDate,
              max: _ctx.maxBirthdayDate,
              onFocus: _cache[10] || (_cache[10] = $event => (_ctx.birthdayErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText", "min", "max"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_select, {
              class: "elment",
              modelValue: _ctx.selectSex,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.selectSex) = $event)),
              label: 'clients.create.sex',
              items: _ctx.sex
            }, null, 8, ["modelValue", "label", "items"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_v_select, {
              class: "elment",
              modelValue: _ctx.selectedClub,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = $event => ((_ctx.selectedClub) = $event)),
                _ctx.selectClub
              ],
              label: 'clients.create.club',
              items: _ctx.clubs,
              errorText: _ctx.clubErrorText,
              onClick: _cache[13] || (_cache[13] = $event => (_ctx.clubErrorText = ''))
            }, null, 8, ["modelValue", "label", "items", "errorText", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_v_select, {
              class: "elment",
              modelValue: _ctx.selectedAgreement,
              "onUpdate:modelValue": [
                _cache[14] || (_cache[14] = $event => ((_ctx.selectedAgreement) = $event)),
                _ctx.selectAgreement
              ],
              label: 'clients.create.agreement',
              items: _ctx.agreements,
              errorText: _ctx.agreementErrorText,
              onClick: _cache[15] || (_cache[15] = $event => (_ctx.agreementErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "items", "errorText", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.activationDate,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((_ctx.activationDate) = $event)),
              inputType: "date",
              label: _ctx.$t('clients.create.contract_activation_date'),
              height: "22",
              errorText: _ctx.activationDateErrorText,
              onFocus: _cache[17] || (_cache[17] = $event => (_ctx.activationDateErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_v_input, {
              class: "elment",
              modelValue: _ctx.paymentDate,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.paymentDate) = $event)),
              inputType: "date",
              label: _ctx.$t('clients.create.payment_date'),
              height: "22",
              errorText: _ctx.paymentDateErrorText,
              onFocus: _cache[19] || (_cache[19] = $event => (_ctx.paymentDateErrorText = '')),
              clearable: ""
            }, null, 8, ["modelValue", "label", "errorText"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_v_select, {
              class: "elment",
              modelValue: _ctx.selectedPaymentMethod,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => ((_ctx.selectedPaymentMethod) = $event)),
              label: 'clients.create.payment_method',
              items: _ctx.paymentMethods
            }, null, 8, ["modelValue", "label", "items"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_v_checkbox, {
                modelValue: _ctx.isCorporateClient,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => ((_ctx.isCorporateClient) = $event)),
                label: _ctx.$t('clients.create.corporate_client')
              }, null, 8, ["modelValue", "label"])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_v_select, {
                class: "elment",
                modelValue: _ctx.selectedOrganizations,
                "onUpdate:modelValue": [
                  _cache[22] || (_cache[22] = $event => ((_ctx.selectedOrganizations) = $event)),
                  _ctx.selectOrganization
                ],
                label: 'clients.create.organization',
                items: _ctx.organizations
              }, null, 8, ["modelValue", "label", "items", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createVNode(_component_v_input, {
                class: "elment new_organization_name",
                modelValue: _ctx.organizationName,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = $event => ((_ctx.organizationName) = $event)),
                label: _ctx.$t('clients.create.organization_name'),
                height: "22",
                errorText: _ctx.organizationNameErrorText,
                onFocus: _cache[24] || (_cache[24] = $event => (_ctx.organizationNameErrorText = '')),
                clearable: ""
              }, null, 8, ["modelValue", "label", "errorText"]), [
                [_vShow, !_ctx.selectedOrganizations?.id]
              ])
            ])
          ], 512), [
            [_vShow, _ctx.isCorporateClient]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.selectedAgreement?.text), 1),
            _createVNode(_component_v_input, {
              modelValue: _ctx.tempContractPrice,
              "onUpdate:modelValue": [
                _cache[25] || (_cache[25] = $event => ((_ctx.tempContractPrice) = $event)),
                _ctx.getTotalPrice
              ],
              inputType: "number",
              label: `${_ctx.$t('clients.create.price')}, ${_ctx.currencySign}`,
              height: "22",
              min: 0,
              step: 0.01,
              onBlur: _ctx.checkContractPrice
            }, null, 8, ["modelValue", "label", "onBlur", "onUpdate:modelValue"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tempSevices, (service, index) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(service.name), 1),
              _createVNode(_component_v_input, {
                modelValue: service.price,
                "onUpdate:modelValue": [$event => ((service.price) = $event), _ctx.getTotalPrice],
                inputType: "number",
                label: `${_ctx.$t('clients.create.price')}, ${_ctx.currencySign}`,
                height: "22",
                min: 0,
                step: 0.01,
                onBlur: $event => (_ctx.checkServicePrice(index))
              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onBlur"])
            ]))
          }), 256))
        ], 512), [
          [_vShow, _ctx.selectedAgreement]
        ]),
        _withDirectives(_createElementVNode("p", { class: "total_price" }, _toDisplayString(_ctx.$t('clients.create.total_price')) + ": " + _toDisplayString(_ctx.getFormatedAmount(_ctx.totalPrice * 100)) + " " + _toDisplayString(_ctx.currencySign), 513), [
          [_vShow, _ctx.selectedAgreement]
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "primary_button button_space",
            onClick: _cache[26] || (_cache[26] = (...args) => (_ctx.save && _ctx.save(...args)))
          }, _toDisplayString(_ctx.$t('clients.create.create')), 1),
          _createElementVNode("button", {
            class: "secondary_button",
            onClick: _cache[27] || (_cache[27] = $event => (_ctx.$router.go(-1)))
          }, _toDisplayString(_ctx.$t('clients.create.back')), 1)
        ])
      ])
    ])
  ], 64))
}